import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { Backdrop, makeStyles, Theme, createStyles } from '@material-ui/core';
import { Reducers } from '../../Interfaces/Interfaces';
import PrimaryTheme from '../../Themes/Primary';
import Spinner from '../../components/Spinner';
import Navigation from '../../components/Navigation';
import ErrorPageSecured from '../../routes/ErrorPageSecured/ErrorPageSecured';
import { spring, AnimatedSwitch, } from 'react-router-transition';
import { Routes } from '../../routes';
import "./securityLayout.scss"
import BlueLogo from "../../images/logo-blue.png"
import MenuLogo from "../../images/menu.png"
export default function SecuredLayout() {
  const classes = useStyles();

  const dispatch = useDispatch()
  const loading = useSelector((state: Reducers) => state.loading)
  const closeSidebarReducer = useSelector((state: any) => state.closeSidebarReducer)

  const [Toggle, setToggle] = React.useState("none");
  // we need to map the `scale` prop we define below
  // to the transform style property
  function mapStyles(styles: any) {
    return {
      opacity: styles.opacity,
      transform: `scale(${styles.scale})`,
    };
  }

  // wrap the `spring` helper to use a bouncy config
  function bounce(val: any) {
    return spring(val, {
      stiffness: 330,
      damping: 22,
    });
  }

  // child matches will...
  const bounceTransition = {
    // start in a transparent, upscaled state
    atEnter: {
      opacity: 0,
      scale: 1.01,
    },
    // leave in a transparent, downscaled state
    atLeave: {
      opacity: bounce(0),
      scale: bounce(0.8),
    },
    // and rest at an opaque, normally-scaled state
    atActive: {
      opacity: bounce(1),
      scale: bounce(1),
    },
  };
  React.useEffect(() => {

    if (closeSidebarReducer) {
      setToggle("none")
    }
  }, [closeSidebarReducer])
  const handleToggle = () => {
    dispatch({ type: "CLOSE_NAVIGATION", payload: false })
    if (Toggle === "none") {
      setToggle("block")
    } else {
      setToggle("none")
    }

  }

  return (
    <div>
      {/* header */}
      {/* <SecuredAppBar /> */}

      <div className="container-fluid">
        <div className="row">
          <div className="col-12 mobile-header">
            <div className="row" style={{ paddingTop: "20px", paddingBottom: "10px" }}>
              <span onClick={handleToggle} style={{ paddingLeft: "10px" }}  >  <img src={MenuLogo} alt="logo" /></span>
              <div className="col" style={{ textAlign: "center", }}>

                <img src={BlueLogo} alt="logo" style={{ width: "50%" }} />


              </div>
            </div>
          </div>
          <div className={"col-md-2  border-right box-shadow-right  d-md-inline p-0 sidebar-cover"} style={{ position: 'relative', display: Toggle }}>
            <div className="col-md-12 col-10 sideBar bg-white pr-0">
              <Navigation />

            </div>
          </div>

          <div className="col ml-auto" style={{
            backgroundColor: PrimaryTheme.white,
            overflowX: "hidden",
            overflowY: "auto",
            minHeight: '100vh',
            height: 'auto'
          }}>
            <div className="col-md-12 bg-white page p-0 app-cover" style={{ ...styles.content, }}>
              <div className="col-12" style={{ background: "#0e94dd", position: "absolute", left: 0, height: "40vh", }}></div>
              <AnimatedSwitch
                atEnter={bounceTransition.atEnter}
                atLeave={bounceTransition.atLeave}
                atActive={bounceTransition.atActive}
                mapStyles={mapStyles}
                className="switch-wrapper"
              >
                {Routes.map((item) =>
                  item.hasAccess && <Route key={item.path} exact path={item.path}>
                    <item.Component />
                  </Route>
                )}
                <Route exact strict path='*'>
                  <ErrorPageSecured />
                </Route>
              </AnimatedSwitch>
            </div>
          </div>

          <Backdrop className={classes.backdrop} open={loading}>
            <Spinner />
          </Backdrop>

        </div>
      </div>
    </div>
  )
}

const styles = {
  header: {
    color: 'dark',
  },
  searchBar: {
    height: 70,
    borderRadius: 50
  },
  sideBar: {
  },
  content: {
    // marginTop: 30,
    // overflow: 'auto',
    // padding: 30
    height: '100vh'
  },
}


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    }, option: {
      fontSize: 15,
      '& > span': {
        marginRight: 10,
        fontSize: 18,
      },
    },
  }),
);
